import React, { useState } from "react"
import { Modal, Zoom } from "@mui/material"
import { CancelOutlined } from "@mui/icons-material"
import LessonView from "./lesson-modal-view"
import QuestionView from "./question-modal-view"


const CourseModal = (props: any) => {
  const { open, onClose, onSubmit, lessons, questions } = props


  // states
  const [mode, setMode] = useState<"lesson" | "question">("lesson")
  const [currentIdx, setCurrentIdx] = useState<number>(0)

  //   functions
  const handleClose = () => {
    setMode("lesson")
    setCurrentIdx(0)
    onClose()
  }
  const handleSubmit = () => {
    onSubmit();
    handleClose()
  }
  const moveToNext = () => {
    const items = mode === "lesson" ? lessons : questions
    if (currentIdx + 1 < items?.length) {
      setCurrentIdx(currentIdx + 1)

    }
  }
  const moveToPrev = () => {
    if (currentIdx > 0) {
      setCurrentIdx(currentIdx - 1)

    }
  }
  const startQuestions = () => {
    setMode("question")
    setCurrentIdx(0)
  }

  return (
    <Modal
      // keepMounted
      open={open}
      onClose={handleClose}
      className="flex items-center justify-center"
      slotProps={{ backdrop: { className: "bg-accent-dark bg-opacity-50" } }}
    >
      <Zoom in={open}>
        <div className="relative max-w-2xl min-w-lg z-5 course-modal" style={{ maxWidth: "500px" }}>
          <div className="flex justify-end items-center mb-10">
            <button className=" text-gray-90 text-2xl" onClick={handleClose}>
              <CancelOutlined className="text-accent-green" />
            </button>
          </div>
          <main className="bg-gray-90 rounded-x10 border border-accent-main  relative z-5 w-full">
            {mode === "lesson" ? (
              lessons && (
                <LessonView
                  lesson={lessons[currentIdx]}
                  isFirst={currentIdx === 0}
                  isLast={currentIdx + 1 === lessons?.length}
                  sn={currentIdx + 1}
                  noOfItems={lessons?.length}
                  moveToNext={moveToNext}
                  moveToPrev={moveToPrev}
                  startQuestions={startQuestions}
                />
              )
            ) : (
              questions && (
                <QuestionView
                  question={questions?.[currentIdx]}
                  isLast={currentIdx + 1 === questions?.length}
                  sn={currentIdx + 1}
                  noOfItems={questions?.length}
                  moveToNext={moveToNext}
                  endQuiz={handleSubmit}
                />
              )
            )}
          </main>
        </div>
      </Zoom>
    </Modal>
  )
}

export default CourseModal
